export default __webpack_public_path__ + "static/licence-QLD-front-d81e85531581cbe4fcd205456a410532.svg";